import type { EasyVrpMapContext } from './EasyVrpMapContext';
import { StyleRouteGenerator } from './StyleRouteGenerator';
import type { Vehicle } from '../../Vehicles/Vehicle';

export class EasyVrpMapRoutesManager {
    private mapElementIds: string[] = [];

    public clearMap() {
        console.log('#map Removing all routes from map');
        this.mapElementIds.forEach(id => {
            Targeo.Base.Map.UORemove(id);
        });
        this.mapElementIds = [];
    }

    public addRoutesToMap(mc: EasyVrpMapContext, selectedRouteId: string | null = null) {
        mc.getRouteIds().forEach(rid => {
            if (selectedRouteId !== null && rid !== selectedRouteId) {
                return; // Skip if not the selected vehicle
            }
            const route = mc.getRouteByRouteId(rid, true, true);
            // const vehicle = mc.getContext().vehicles.find((v: Vehicle) => v.getId() === vehicleId);
            let color: string | undefined = mc.getColor(rid) ?? undefined;
            if (route.length === 0) {
                console.warn(`#map No routes found for route ID ${rid}`);
                return;
            }
            try {
                const routeId = `route_${rid}_${route[0].x}_${route[0].y}`;
                let line = new Targeo.MapObject.Polyline(
                    StyleRouteGenerator.getPointsFormatted(route),
                    StyleRouteGenerator.getStyle(color),
                    routeId
                );
                this.mapElementIds.push(routeId);
                Targeo.Base.Map.UOAdd(line);
            } catch (error) {
                console.warn(
                    'No valid route found for selectedRouteId',
                    selectedRouteId,
                    'Error:',
                    error
                );
            }
        });

        // Add routes without assigned vehicles
        mc.getRoutesWithoutVehicle().forEach(r => {
            const randomId = Math.floor(Math.random() * 1000000).toString();
            const routeId = `route_${randomId}_${r.route[0][0]}_${r.route[0][1]}`;
            console.log('#map Drawing route without vehicle', routeId, r.route);
            let line = new Targeo.MapObject.Polyline(
                StyleRouteGenerator.getPointsFormatted(
                    r.route.map(coords => ({ x: coords[0], y: coords[1] }))
                ),
                StyleRouteGenerator.getStyle(),
                routeId
            );
            this.mapElementIds.push(routeId);
            Targeo.Base.Map.UOAdd(line);
        });
    }
}
